<div class="cas-dashboard">

    <!--    <p>We will display some general stats here, e.g. number of projects in n sites; number of CAP, etc.</p>-->
    <acabim-donut-chart *ngIf="!isLoading else loadingView" #chart size="250" [responsive]="true" fontsize="8"
                        [dataSource]="dataSource"></acabim-donut-chart>
    <p class="w-100" style="text-align: center; font-size: small; font-style: italic;">
        Note: Sites are denoted by colours;<br/>
        each segment within a site is a project;<br/>Number of CAPs in a project is denoted by p3:5, <br/>i.e. 5 CAPs assigned to project 3</p>

</div>
<ng-template #loadingView>
    <acabim-loading-view></acabim-loading-view>
</ng-template>
